import axios from 'axios';

const server = process.env.REACT_APP_SERVER_URL;


export const getPublicidadAuto = async (token: string) => {
  const res = await axios.get(`${server}/publicidad-auto`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};


export const getPublicidadAutoById = async (id: number, token: string) => {
  const res = await axios.get(`${server}/publicidad-auto/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};


export const createPublicidadAuto = async (data: { documento: string; mmv: number }, token: string) => {
  const res = await axios.post(`${server}/publicidad-auto`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};


export const updatePublicidadAuto = async (id: number, data: { documento: string; mmv: number }, token: string) => {
  const res = await axios.put(`${server}/publicidad-auto/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};


export const deletePublicidadAuto = async (id: number, token: string) => {
  const res = await axios.delete(`${server}/publicidad-auto/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};
